import { SessionPermissionsMessage } from "../../../messages/session/SessionMessages";
import { busService } from "../../bus";
class SessionPermissionsService {
    constructor() {
        this.connection = busService.connection("SessionPermissionsService");
        this.sessionPermissions = [];
        this.handleSessionPermissionsMessage = (msg) => {
            this.sessionPermissions = msg.permissions;
        };
        this.connection.subscribeByType(SessionPermissionsMessage, this.handleSessionPermissionsMessage);
    }
    hasPermission(permission) {
        return this.sessionPermissions.includes(permission);
    }
}
export const sessionPermissionsService = new SessionPermissionsService();
